import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrepagaService {
  private apiUrl = environment.apiPlataforma;

  constructor(private http: HttpClient) {}

  nuevo_prospecto(token: string | null, data: any, uuid_origen: string | null): Observable<any> {

    const url = `${this.apiUrl}/api/v1/prepaga/prospecto`;
    const headers = { 'Authorization': `Bearer ${token}` };


    // Construir objeto con los nombres que espera el backend
    const dataToSend: any = {
      nombre: data.nombre,
      apellido: data.apellido,
      edad: data.edad,
      edadPareja: data.edadPareja,
      cantidadHijos: data.cantidadHijos,
      localidad: data.localidad,
      provincia: data.provincia,
      documento: data.documento,
      trabajo: data.trabajo,
      telefono: data.telefono,
      email: data.email,
      uuid_origen: uuid_origen,
    };

    // Agregar edades de hijos como hijo1_edad, hijo2_edad, ...
    if (data.cantidadHijos && data.cantidadHijos > 0) {
      for (let i = 0; i < data.cantidadHijos; i++) {
        const edadHijo = data['edadHijo' + i];
        if (edadHijo !== undefined && edadHijo !== null && edadHijo !== '') {
          dataToSend['hijo' + (i + 1) + '_edad'] = edadHijo;
        }
      }
    }

    const options = {
      headers: headers
    }

    return this.http.post<any>(url, dataToSend, options);

  }
}
